var map = {
	"./core/i18n/locales/bn.json": 5620,
	"./core/i18n/locales/en.json": 5775,
	"./core/i18n/locales/th.json": 2752,
	"./core/i18n/locales/zh.json": 7010,
	"./modules/auth/locales/bn.json": 8414,
	"./modules/auth/locales/en.json": 2653,
	"./modules/auth/locales/th.json": 8058,
	"./modules/auth/locales/zh.json": 24,
	"./modules/bank/locales/bn.json": 7866,
	"./modules/bank/locales/en.json": 5793,
	"./modules/bank/locales/th.json": 4006,
	"./modules/bank/locales/zh.json": 1724,
	"./modules/deposit/locales/bn.json": 4076,
	"./modules/deposit/locales/en.json": 1751,
	"./modules/deposit/locales/th.json": 888,
	"./modules/deposit/locales/zh.json": 8922,
	"./modules/games/locales/bn.json": 2035,
	"./modules/games/locales/en.json": 5488,
	"./modules/games/locales/th.json": 9763,
	"./modules/games/locales/zh.json": 4657,
	"./modules/home/locales/bn.json": 2993,
	"./modules/home/locales/en.json": 5578,
	"./modules/home/locales/th.json": 6753,
	"./modules/home/locales/zh.json": 9651,
	"./modules/kyc/locales/bn.json": 4257,
	"./modules/kyc/locales/en.json": 6330,
	"./modules/kyc/locales/th.json": 529,
	"./modules/kyc/locales/zh.json": 1987,
	"./modules/lucky-draw/locales/bn.json": 871,
	"./modules/lucky-draw/locales/en.json": 8876,
	"./modules/lucky-draw/locales/th.json": 7047,
	"./modules/lucky-draw/locales/zh.json": 9693,
	"./modules/profile/locales/bn.json": 2645,
	"./modules/profile/locales/en.json": 9334,
	"./modules/profile/locales/th.json": 9637,
	"./modules/profile/locales/zh.json": 1695,
	"./modules/promotion/locales/bn.json": 7905,
	"./modules/promotion/locales/en.json": 3546,
	"./modules/promotion/locales/th.json": 8017,
	"./modules/promotion/locales/zh.json": 5091,
	"./modules/transaction/locales/bn.json": 6630,
	"./modules/transaction/locales/en.json": 565,
	"./modules/transaction/locales/th.json": 7586,
	"./modules/transaction/locales/zh.json": 9680,
	"./modules/wallet-transfer/locales/bn.json": 2319,
	"./modules/wallet-transfer/locales/en.json": 5892,
	"./modules/wallet-transfer/locales/th.json": 3567,
	"./modules/wallet-transfer/locales/zh.json": 5157,
	"./modules/withdrawal/locales/bn.json": 9829,
	"./modules/withdrawal/locales/en.json": 6822,
	"./modules/withdrawal/locales/th.json": 5557,
	"./modules/withdrawal/locales/zh.json": 3823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6900;